/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_EmptyInputs */

const vi_warehouse_defects_empty = /** @type {(inputs: Warehouse_Defects_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có sản phẩm lỗi trong khoảng thời gian này`)
};

/**

* @param {Warehouse_Defects_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_empty = /** @type {((inputs?: Warehouse_Defects_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_empty(inputs)
});